import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { RoomProvider } from './context/RoomContext';
import { ThemeProvider } from './context/ThemeContext';
import Navbar from './components/Navbar';
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import RoomsPage from './pages/RoomsPage';
import RoomDetailPage from './pages/RoomDetailPage';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminRooms from './pages/admin/AdminRooms';
import AdminBookings from './pages/admin/AdminBookings';
import AdminAccounts from './pages/admin/AdminAccounts';
import AdminSettings from './pages/admin/AdminSettings';
import AdminReports from './pages/admin/AdminReports';
import BookingDetailPage from './pages/admin/BookingDetailPage';

function App() {
  return (
    <AuthProvider>
      <RoomProvider>
        <ThemeProvider>
          <Router>
            <div className="min-h-screen bg-gray-50 flex flex-col">
              <Navbar />
              <div className="flex-grow">
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/login" element={<LoginPage />} />
                  <Route path="/rooms" element={<RoomsPage />} />
                  <Route path="/rooms/:id" element={<RoomDetailPage />} />
                  <Route path="/admin" element={<AdminDashboard />}>
                    <Route path="rooms" element={<AdminRooms />} />
                    <Route path="bookings" element={<AdminBookings />} />
                    <Route path="accounts" element={<AdminAccounts />} />
                    <Route path="reports" element={<AdminReports />} />
                    <Route path="settings" element={<AdminSettings />} />
                  </Route>
                  <Route path="/admin/bookings/:id" element={<BookingDetailPage />} />
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
              </div>
              <footer className="bg-white border-t border-gray-200 py-6 mt-auto">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                  <p className="text-center text-gray-500 text-sm">
                    &copy; {new Date().getFullYear()} RoomBooker. All rights reserved.
                  </p>
                </div>
              </footer>
            </div>
          </Router>
        </ThemeProvider>
      </RoomProvider>
    </AuthProvider>
  );
}

export default App;